import { styled } from "@mui/material/styles";
import { Box, Typography, IconButton, ListItem, Chip } from "@mui/material";
import theme from "../../../theme";
import ProgressLoader from "../../../loader/ProgressLoader";

export const RequisitionListItem = styled(ListItem)`
  padding: 0 10px 10px 10px;
`;

export const RequisitionContainer = styled(Box)`
  overflow: hidden;
  width: 100%;
`;

export const RequisitionCard = styled(Box)`
  cursor: pointer;
  border: 1px solid ${theme.palette.grey[300]};
  border-radius: 8px;
  &:hover {
    background: ${theme.palette.grey[100]};
  }
`;

export const RequisitionStatusChip = styled(Chip)`
  font-size: 11px;
  height: 20px;
  font-weight: 500;
  margin-left: -2px;
`;

export const RequisitionHeader = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 8px;
`;

export const RequisitionContent = styled(Box)`
  flex: 1;
  min-width: 0;
`;

export const TestNameText = styled(Typography)`
  overflow: hidden;
`;

export const EditButton = styled(IconButton)`
  color: ${theme.palette.grey[600]};

  &:hover {
    color: ${theme.palette.primary.main};
    background-color: rgba(59, 130, 246, 0.04);
  }
`;

export const ExpandedContent = styled(Box)`
  padding: 0;
`;

export const Loader = styled(ProgressLoader)`
  height: auto;
`;

export const ExpandIconButton = styled(IconButton)`
  padding: 3px;
`;
